import React, { useRef, useState } from "react";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import questionMarkIcon from "@src/assets/png/question-mark-circle.png";

import styles from "./question-mark-with-popover-for-condition-monitoring.module.scss";
import { useClickOutsideListener } from "@src/hooks/use-click-outside-listener";
import { HorizontalSeparator } from "@components/atoms/horizontal-separator/horizontal-separator";
import { GradientBorderContainer } from "@components/templates/layouts/gradient-border-container/gradient-border-container";
import { useI18N } from "@src/language/language-context";

const cssClassName = "question-mark-with-popover-for-condition-monitoring";

export const QuestionMarkWithPopoverForConditionMonitoring = () => {
  const i18n = useI18N();
  const popoverRef = useRef();
  const [isHelpPopoverOpen, setIsHelpPopoverOpen] = useState(false);

  const texts = {
    explanation: i18n(
      "modules.questionMarkWithPopoverForConditionMonitoring.explanation",
    ),
    descriptionAnd: i18n(
      "modules.questionMarkWithPopoverForConditionMonitoring.descriptionAnd",
    ),
    descriptionOr: i18n(
      "modules.questionMarkWithPopoverForConditionMonitoring.descriptionOr",
    ),
  };

  const handleClickOnQuestionMark = () => {
    const toggle = (prev) => !prev;
    setIsHelpPopoverOpen(toggle);
  };

  useClickOutsideListener(
    popoverRef,
    handleClickOnQuestionMark,
    isHelpPopoverOpen,
  );

  return (
    <div ref={popoverRef} className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__icon-wrapper`]}>
        <IconButton fun={handleClickOnQuestionMark} icon={questionMarkIcon} />
      </div>
      {isHelpPopoverOpen && (
        <div className={styles[`${cssClassName}__popover-wrapper`]}>
          <GradientBorderContainer>
            <div className={styles[`${cssClassName}__popover`]}>
              <p className={styles[`${cssClassName}__explanation`]}>
                {texts.explanation}
              </p>
              <HorizontalSeparator />
              <div className={styles[`${cssClassName}__lower-wrapper`]}>
                <div
                  className={
                    styles[`${cssClassName}__label-description-wrapper`]
                  }
                >
                  <p className={styles[`${cssClassName}__description`]}>
                    {texts.descriptionAnd}
                  </p>
                </div>
                <div
                  className={
                    styles[`${cssClassName}__label-description-wrapper`]
                  }
                >
                  <p className={styles[`${cssClassName}__description`]}>
                    {texts.descriptionOr}
                  </p>
                </div>
              </div>
            </div>
          </GradientBorderContainer>
        </div>
      )}
    </div>
  );
};
